import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guide-o365-service-account',
  templateUrl: './guide-o365-service-account.component.html',
  styleUrls: ['./guide-o365-service-account.component.scss']
})
export class GuideO365ServiceAccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
